import React from "react";
import { Link } from "components/common";
import CollectionsRoutes from "../../../Routes";
const TitleCell = ({ id, title }) => /* @__PURE__ */ React.createElement(Link, { to: CollectionsRoutes.show(id) }, title);
export default TitleCell;
